import { Team, ArticleOrder, ArticleSort, ArticleVariant, TagsMatchMode } from '@repo/types';

export type ArticleListFormData = {
  title?: string;
  startDate?: string;
  endDate?: string;
  tags?: string;
  tagsMatchMode?: TagsMatchMode;
  teamFromSlug?: boolean;
  filterByTags?: boolean;
  excludeTags?: string;
  excludeIds?: string;
  withPagination?: boolean;
  lazyLoad?: boolean;
  page?: number;
  limit?: number;
  sort?: ArticleSort;
  order?: ArticleOrder;
  variant?: ArticleVariant;
  listVariant?: ArticleListVariant;
  showImage?: boolean;
  showAuthor?: boolean;
  showTag?: boolean;
  showDate?: boolean;
  showSummary?: boolean;
  columns?: number;
};

export enum ArticleListVariant {
  Default = 'default',
  TwoColumnGrid = 'TwoColumnGrid',
}

export type ArticleListProps = ArticleListFormData & {
  extraData?: {
    team?: Team;
  };
  prioritize?: boolean;
  searchParams?: { [key: string]: string | string[] | undefined };
};
